module.exports = "/_next/static/resources/woman-1-be6babe37d04dc07c9d5d770054af33f.webp";